class GalleryVideo {
  constructor() {
    this.init();
    this.bindEvents();
  }

  init() {
    this.updateListeners();
  }

  updateListeners() {
    const containers = document.querySelectorAll('deferred-media[data-gallery-video]');
    containers.forEach(container => {
      if (container.dataset.listenerAdded) return;
      
      container.addEventListener('click', (e) => {
        // Prevent clicking through to the lightbox if we're just toggling play/pause
        // BUT wait, clicking a thumbnail SHOULD open the lightbox if it's NOT a play button?
        // Actually, the user says "when i click it should start the video".
        // This implies the video in the GALLERY should play, NOT open the lightbox.
        
        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');

        if (!container.getAttribute('loaded')) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof container.loadContent === 'function') {
            container.loadContent();
            const observer = new MutationObserver((mutations) => {
              const newVideo = container.querySelector('video');
              const newIframe = container.querySelector('iframe');
              if (newVideo) {
                this.addVideoListeners(newVideo, container);
                newVideo.play().catch(() => {});
                observer.disconnect();
              }
              if (newIframe) {
                this.postMessage(newIframe, 'playVideo');
                observer.disconnect();
              }
            });
            observer.observe(container, { childList: true, subtree: true });
          }
        } else {
          if (video) {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) video.play();
            else video.pause();
          }
        }
      });
      container.dataset.listenerAdded = 'true';
    });
  }

  addVideoListeners(video, container) {
    video.addEventListener('play', () => {
      container.classList.add('is-playing');
      container.classList.remove('is-paused');
    });
    video.addEventListener('pause', () => {
      container.classList.add('is-paused');
      container.classList.remove('is-playing');
    });
  }

  postMessage(iframe, command) {
    if (!iframe || !iframe.contentWindow) return;
    const event = command === 'playVideo' ? 'play' : 'pause';
    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command, args: '' }), '*');
    iframe.contentWindow.postMessage(JSON.stringify({ method: event }), '*');
  }

  bindEvents() {
    document.addEventListener('modal-opened', () => this.pauseAll());
    document.addEventListener('product-info:loaded', () => {
      setTimeout(() => this.updateListeners(), 500);
    });
  }

  pauseAll() {
    const videos = document.querySelectorAll('deferred-media[data-gallery-video] video');
    const iframes = document.querySelectorAll('deferred-media[data-gallery-video] iframe');
    videos.forEach(v => v.pause());
    iframes.forEach(i => this.postMessage(i, 'pauseVideo'));
  }
}

if (window.customElements) {
  document.addEventListener('DOMContentLoaded', () => {
    window.galleryVideoHandler = new GalleryVideo();
  });
}
